import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3346bcbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_historicalNav = _resolveComponent("historicalNav")!
  const _component_donateComp = _resolveComponent("donateComp")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_historicalNav),
      _createVNode(_component_donateComp)
    ])
  ]))
}